import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  object-fit: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { withOmitProps } from '../helpers/elements';
import { fullSizeAbsoluteStyle } from '../tokens/full-size';
import { overflowHiddenStyle, overflowStyle } from '../tokens/overflow';
var ImageAbsolute = styled.img.withConfig(withOmitProps(['fit', 'rounded', 'circle']))(_templateObject(), function (_ref) {
  var _ref$fit = _ref.fit,
      fit = _ref$fit === void 0 ? 'cover' : _ref$fit;
  return fit;
}, fullSizeAbsoluteStyle, overflowStyle, overflowHiddenStyle, function (_ref2) {
  var _ref2$rounded = _ref2.rounded,
      rounded = _ref2$rounded === void 0 ? false : _ref2$rounded;
  return rounded && "border-radius: 4px;";
}, function (_ref3) {
  var _ref3$circle = _ref3.circle,
      circle = _ref3$circle === void 0 ? false : _ref3$circle;
  return circle && "border-radius: 50%;";
});
export default ImageAbsolute;